import React from 'react';
import { node, string } from 'prop-types';

import css from './EditServiceListingForm.css';

/**
 * A field's label and its description above the input (Figma: Body/Sm
 * Semibold label, Body/Sm secondary description). With an id the label
 * points at that input.
 */
const FieldHeader = ({ id, label, description }) => (
  <div className={css.fieldHeader}>
    {id ? (
      <label htmlFor={id} className={css.fieldLabel}>
        {label}
      </label>
    ) : (
      <span className={css.fieldLabel}>{label}</span>
    )}
    {description ? <p className={css.fieldDescription}>{description}</p> : null}
  </div>
);

FieldHeader.defaultProps = {
  id: null,
  description: null,
};

FieldHeader.propTypes = {
  id: string,
  label: node.isRequired,
  description: node,
};

export default FieldHeader;
